var map = {
	"./C000020.png": "68a6",
	"./Coin.png": "160a",
	"./H000010_sprout.png": "4200",
	"./H000020_mushroom.png": "4b26",
	"./H000030_popcandy.png": "7cc9",
	"./H000040_paperplane.png": "c7e6",
	"./H000050_pencil.png": "d334",
	"./H000060_flower.png": "1c51",
	"./H000070_windmill.png": "4f6a",
	"./H000080_blackcap.png": "25c1",
	"./H000090_fishhead.png": "0421",
	"./H000100_fishtail.png": "450e",
	"./H000110_fishred.png": "00d5",
	"./H000120_rottoenapple.png": "f91d",
	"./H000130_applegreen.png": "7311",
	"./H000140_apple.png": "7705",
	"./H000150_goldenapple.png": "554d",
	"./H000160_bluewhale.png": "00d3",
	"./H000170_crab.png": "6cb3",
	"./H000180_starfish.png": "48e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05f2";